export enum NonTermViewTypeEnum {
    ELECTIVES = "elective",
    ADDITIONAL_SUBJECTS = "additional_subject",
    DEFAULT = "default"
}
